import React from 'react'

import styles from '@components/typography/page_subheadline.module.scss'

const PageSubheadline = ({ classes = '', children }) => (
  <h1 className={`${styles.page_subheadline} ${classes}`}>{children}</h1>
)

export { PageSubheadline }
